// Library import
import axios from 'axios';

// File Import
import {apiEndPoints} from './apiEndPoints';

export class TagApi {
    // Create new user
    static getTags(typeParam) {
        return axios.get(apiEndPoints.TAGS.GET_TAGS(typeParam));
    }
}
